// ── Le passage de l'assistant au support humain : le brouillon prerempli (A12, chantier ASI) ──
import { ASSISTANT_LIMITS } from '@/lib/schemas/assistant.schema';
import type { AssistantConversation } from '@/lib/schemas/support.schema';
import type { Conversation } from './assistant-state';
import type { SupportDraft } from './SupportProvider';

/** La conversation telle qu'elle part avec la demande : les questions et les reponses ecrites */
export function conversationToJoin(c: Conversation): AssistantConversation {
  return c.messages
    .filter(m => m.role === 'user' || m.text.trim().length > 0)
    .slice(-ASSISTANT_LIMITS.joinedMaxMessages)
    .map(m => ({ role: m.role, text: m.text.slice(0, ASSISTANT_LIMITS.historyMessageMaxChars), ...(m.sources?.length ? { sources: m.sources } : {}) }));
}

/**
 * L'objet « Une question », un message qui cite la premiere question, et la conversation jointe. Un brouillon deja
 * ecrit n'est pas ecrase : la citation s'ajoute a la suite, et son objet reste.
 */
export function draftFromAssistant(draft: SupportDraft, c: Conversation): SupportDraft {
  const joined = conversationToJoin(c);
  const first = joined.find(m => m.role === 'user');
  if (!first) return draft;
  const quote = `J'ai demandé à l'assistant : « ${first.text} ». Sa réponse ne m'a pas suffi : `;
  const written = draft.body.trim().length > 0;
  // Un second passage par « Ecrire au support » ne recopie pas la citation : seule la conversation se met a jour
  if (draft.body.includes(quote.trim())) return { ...draft, assistant: joined };
  return {
    ...draft,
    kind: written ? draft.kind : 'QUESTION',
    body: written ? `${draft.body.trimEnd()}\n\n${quote}` : quote,
    assistant: joined,
  };
}
